import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { btnP, crd } from "../../constants/styles";
import Fld from "../common/Fld";

function TenSubMaint() {
  const { t, h, mts, setMts, tens, go, flash, currUserId, addNotif } = useContext(Ctx); const ct = currUserId; const [desc, sD] = useState(""); const [urg, sG] = useState("med");
  const me = tens.find(x => x.id === ct);
  return <div style={{ paddingTop: 16 }}><button onClick={() => go("maint")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.submit}</h2>
    <div style={{ ...crd(h), padding: 20 }}>
      <Fld l={t.desc} v={desc} set={sD} h={h} />
      <label style={{ color: h.sc, fontSize: 12, fontWeight: 500, display: "block", marginBottom: 6 }}>{t.urgency}</label>
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>{["low", "med", "high"].map(u => <button key={u} onClick={() => sG(u)} style={{ flex: 1, padding: 8, borderRadius: 10, border: `1px solid ${urg === u ? h.ac : h.bd}`, background: urg === u ? `${h.ac}15` : "transparent", color: urg === u ? h.ac : h.sc, cursor: "pointer", fontSize: 12 }}>{u === "low" ? t.low : u === "med" ? t.med : t.high}</button>)}</div>
      <button onClick={() => {
        if (!desc) return;
        const newMaint = { id: `m${Date.now()}`, tid: ct, desc, urg, st: "open", dt: new Date().toISOString().slice(0, 10) };
        setMts([newMaint, ...mts]);
        api.saveMaintenance(newMaint);
        addNotif("landlord", null, `${me?.name || "Tenant"} submitted maintenance: "${desc}" (${urg})`, "info");
        addNotif("tenant", ct, `Your maintenance request "${desc}" has been submitted.`, "info");
        flash(t.submitted); go("maint");
      }} style={btnP(h)}>{t.submit}</button>
    </div></div>;
}

export default TenSubMaint;
